import { unregister } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // this will unregister any registered service workers that are already installed
  unregister()
}
